import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/common/ErrorBoundary';
import LoginPage from './pages/auth/LoginPage';
import SuccessPage from './pages/user/SuccessPage';
import CheckInPage from './pages/user/CheckInPage';
import NewUserPage from './pages/user/NewUserPage';
import DependentsPage from './pages/user/DependentsPage';
import EmergencyContactPage from './pages/user/EmergencyContactPage';
import AdminLoginPage from './pages/auth/AdminLoginPage';
import AdminPanelPage from './pages/admin/AdminPanelPage';
import ManageVolunteersPage from './pages/admin/ManageVolunteersPage';
import ReportsTimePage from './pages/admin/reports/ReportsTimePage';
import SettingsPage from './pages/admin/SettingsPage';
import ChangePasswordPage from './pages/admin/ChangePasswordPage';
import AdminOnboardPage from './pages/admin/AdminOnboardPage';
import AdminResetPasswordPage from './pages/admin/AdminResetPasswordPage';
import NotificationsPage from './pages/admin/NotificationsPage';
import ReportsDirectoryPage from './pages/admin/reports/ReportsDirectoryPage';
import ReportsCalendarPage from './pages/admin/reports/ReportsCalendarPage';
import EmergencyContactsPage from './pages/admin/EmergencyContactsPage';
import LiabilityWaiversPage from './pages/admin/LiabilityWaiversPage';
import ResetLiabilityWaiversPage from './pages/admin/ResetLiabilityWaiversPage';
import FixMidnightHoursPage from './pages/admin/FixMidnightHoursPage';
import ActivityLogPage from './pages/admin/ActivityLogPage';
import FeedbackPage from './pages/admin/FeedbackPage';
import UpdateLiabilityWaiverPage from './pages/user/UpdateLiabilityWaiverPage';
import QRCodeLoginPage from './pages/user/QRCodeLoginPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/checkin" element={<CheckInPage />} />
            <Route path="/new-user" element={<NewUserPage />} />
            <Route path="/dependents" element={<DependentsPage />} />
            <Route path="/emergency-contact" element={<EmergencyContactPage />} />
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/admin-panel" element={<AdminPanelPage />} />
            <Route path="/admin/manage-volunteers" element={<ManageVolunteersPage />} />
            <Route path="/admin/reports-time" element={<ReportsTimePage />} />
            <Route path="/admin/settings" element={<SettingsPage />} />
            <Route path="/admin/change-password" element={<ChangePasswordPage />} />
            <Route path="/admin/onboard/:token" element={<AdminOnboardPage />} />
            <Route path="/admin/reset-password/:token" element={<AdminResetPasswordPage />} />
            <Route path="/admin/notifications" element={<NotificationsPage />} />
            <Route path="/admin/reports-directory" element={<ReportsDirectoryPage />} />
            <Route path="/admin/reports-calendar" element={<ReportsCalendarPage />} />
            <Route path="/admin/emergency-contacts" element={<EmergencyContactsPage />} />
            <Route path="/admin/liability-waivers" element={<LiabilityWaiversPage />} />
            <Route path="/admin/reset-liability-waivers" element={<ResetLiabilityWaiversPage />} />
            <Route path="/admin/fix-midnight-hours" element={<FixMidnightHoursPage />} />
            <Route path="/admin/activity-log" element={<ActivityLogPage />} />
            <Route path="/admin/feedback" element={<FeedbackPage />} />
            <Route path="/liability-waiver" element={<UpdateLiabilityWaiverPage />} />
            <Route path="/qrcode-login" element={<QRCodeLoginPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
